import { useAutoAnimate } from "@formkit/auto-animate/react";
import { useState } from "react";
import { FiChevronDown, FiChevronRight } from "react-icons/fi";
import { useSearchParams } from "react-router-dom";
import SelectBox from "../Common/SelectBox";
import { useCurrentParams } from "../../hooks/useCurrentParams";

const SortBy = () => {
  const [openSort, setOpenSort] = useState(true);
  const [parent] = useAutoAnimate();

  const [searchParams, setSearchParams] = useSearchParams();
  const [currentSearchParams] = useCurrentParams();

  const options = [
    { value: "popularity.desc", label: "Most popular" },
    { value: "vote_average.desc", label: "Most rating" },
    { value: "release_date.desc", label: "Most recent" },
  ];

  const chooseSort = (option) => {
    const sortValue = option?.value || "";

    setSearchParams({
      ...currentSearchParams,
      sort_by: sortValue,
    });
  };

  const sortType = searchParams.get("sort_by") || "popularity.desc";

  return (
    <div
      ref={parent}
      className="bg-dark-lighten rounded-md shadow-md px-4 pt-3 transition duration-500"
    >
      <div
        className="flex justify-between items-center text-white pb-3 cursor-pointer"
        onClick={() => setOpenSort((prev) => !prev)}
      >
        <p className="text-lg">Sort</p>
        <button>
          {openSort && <FiChevronDown size={20} />}
          {!openSort && <FiChevronRight size={20} />}
        </button>
      </div>
      {openSort && (
        <div className="py-3">
          <div className="mb-4 text-dark-darken rounded-full border-2 border-gray-darken">
            <p className="px-4 py-2 bg-white text-dark-darken rounded-full uppercase font-medium w-fit">
              Sort results by
            </p>
          </div>
          <SelectBox
            options={options}
            defaultValue={options[0]}
            value={options.find((option) => option.value === sortType)}
            onChange={chooseSort}
            type="light"
          />
        </div>
      )}
    </div>
  );
};

export default SortBy;
